import React from "react";
import { reduxForm } from "redux-form";
import { compose, withHandlers, mapProps } from "recompose";
import styled from "styled-components";
import { SubmissionError } from "redux-form";
import { Form, FormError, SubmitButton } from "app/forms";
import * as forms from "app/forms";
import { ADD_COMMENT } from "./constants";
import { connectCommentActions } from "./hocs";
import CommentList from "./CommentList";
import * as validate from "app/validate";
import { withAuth } from "app/auth/hocs";
import { withRouter } from "react-router-dom";
import { AppToaster } from "app/toaster";
import { Intent } from "@blueprintjs/core";
import { injectIntl } from "react-intl";

const ButtonsWrapper = styled.div`
  margin: 1em 0;
`;

const enhanceField = compose(
  forms.reduxField,
  forms.interactive,
  forms.unlabelled
);
const TextArea = enhanceField(forms.CustomTextArea);

export const CommentField = props => {
  const { intl } = props;
  return (
    <TextArea
      type="text"
      label={intl.formatMessage({
        id: "proposal.comment",
        defaultMessage: "Comment"
      })}
      {...props}
      name="comment"
    />
  );
};

const Buttons = props => {
  const { valid, submitting, intl } = props;
  return (
    <ButtonsWrapper>
      <SubmitButton
        valid={valid}
        submitting={submitting}
        text={intl.formatMessage({
          id: "text.submit",
          defaultMessage: "Submit"
        })}
        className="pt-intent-primary"
      />
    </ButtonsWrapper>
  );
};

const onSubmit = props => values => {
  const { resourceType, resourceId, createComment } = props;
  const { comment } = values;
  return createComment({ comment, resourceType, resourceId }).catch(error => {
    if (error && error.type === ADD_COMMENT.ERROR) {
      throw new SubmissionError({ _error: error });
    }
    throw error;
  });
};

const onSubmitSuccess = () => (result, dispatch, props) => {
  props.reset();
};

const showToast = message => {
  AppToaster.show({
    iconName: "warning-sign",
    intent: Intent.WARNING,
    message
  });
};

const onFocus = props => () => {
  const {
    auth: { isAuthenticated },
    history,
    intl
  } = props;

  let path = window.location.href.split("/");
  if (!isAuthenticated) {
    showToast(
      intl.formatMessage({
        id: "toast.loggedin.message",
        defaultMessage: "You must be logged in to make a comment."
      })
    );
    history.push("/login", {
      from: {
        pathname: `${path[3]}/${path[4]}/${path[5]}/${path[6]}`
      },
      showWarning: true
    });
  }
};

const formEnhancer = compose(
  withAuth,
  withRouter,
  connectCommentActions,
  injectIntl,
  withHandlers({
    onSubmit,
    onSubmitSuccess,
    onFocus
  }),
  reduxForm({
    form: "commentForm"
  })
);

const CommentForm = formEnhancer(props => {
  const { handleSubmit, submitting, valid, error, onFocus, intl } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <CommentField
        validate={[validate.required]}
        onFocus={onFocus}
        intl={intl}
      />
      <FormError error={error} submitting={submitting} />
      <Buttons valid={valid} submitting={submitting} intl={intl} />
    </Form>
  );
});

const Comments = props => {
  const { proposalId: resourceId, resourceType, intl } = props;
  // const resourceType = isDraft ? "Draft" : "Proposal";
  const params = { resourceType, resourceId, intl };
  return (
    <div>
      <CommentForm {...params} />
      <CommentList {...params} />
    </div>
  );
};

// enhance the Comments component with the appropriate resourceType
export default mapProps(props => {
  const { isDraft } = props;
  return {
    resourceType: isDraft ? "Draft" : "Proposal",
    ...props
  };
})(Comments);



// WEBPACK FOOTER //
// ./src/app/comments/Comments.js